'use client';
import React from 'react';
import Slider from 'react-slick';
import MWSVG from '@/components/common/svg';

const engagementModels = [
    {
        heading: 'AI Discovery Workshop',
        headingClass: 'bg-discovery-design',
        title: 'What you get:',
        desc: 'A structured session to identify where AI creates real value for your organization, assess readiness, surface risks, and define a realistic scope for the first initiative. Ideal for enterprises at the beginning of their AI journey.',
        points: [
            'Use case prioritization map',
            'Data and systems readiness assessment',
            'Recommended starting point and timeline',
        ],
    },
    {
        heading: 'AI Roadmap and Architecture Sprint',
        headingClass: 'bg-deployment-monitoring',
        title: 'What you get:',
        desc: 'A deeper engagement to define your AI roadmap, solution architecture, technology stack, delivery plan, and budget range. Designed for organizations ready to move from strategy to execution.',
        points: [
            'Detailed AI roadmap document',
            'Architecture and technology recommendations',
            'Cost and delivery estimate for the first phase',
        ],
    },
    {
        heading: 'MVP and Pilot Implementation',
        headingClass: 'bg-integration-testing',
        title: 'What you get:',
        desc: 'Build a focused AI, automation, or modernization pilot with defined scope, measurable success criteria, and a delivery team already aligned to your business goals. The fastest path from conversation to working software.',
        points: [
            'Working pilot or MVP delivered to production',
            'Performance and outcome metrics',
            'Recommendations for scaling',
        ],
    },
    {
        heading: 'Dedicated Product Engineering Team',
        headingClass: 'bg-fine-tuning',
        title: 'What you get:',
        desc: 'Scale execution with a dedicated team for long-term AI development, SaaS product engineering, enterprise platform development, or modernization programmes. Full IP ownership, transparent reporting, and direct team access.',
        points: [
            'Dedicated engineers, architects, and QA resources',
            'AI and technology landscape advisory',
            'Sprint-based delivery with full visibility',
        ],
    },
];

const UsaEngageAfter = () => {
    const sliderSettings = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1280, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    return (
        <section className="relative section-py case-study overflow-hidden">
            <div className="container lg:container md:mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12 text-center">
                        <div className="gradient-border mb-2">
                            <span className="gradient-text">Engagement Models</span>
                        </div>
                        <h2 className="text-primary mb-4">How We Can Engage After the USA Meeting</h2>
                        <div className="text-white fw-700">
                            Most engagements begin with a focused conversation. Here is how organizations typically move from that
                            first <div>meeting to working with Moweb.</div>
                        </div>
                    </div>
                </div>

                <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider">
                    <div className="container-fluid lg:container-fluid mx-auto">
                        <Slider {...sliderSettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                            {engagementModels.map((model, index) => (
                                <div key={index}>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card rounded-10 industrywise-cases glass-effect-aiml !min-h-[520px]">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className={`industrywise-case-heading ${model.headingClass}`}>
                                                            <h3 className="fs-lg text-white">{model.heading}</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="card-title mb-4 fs-md text-[#D7DEE5]">{model.desc}</p>
                                                            <p className="fs-mdlg mb-2.5 fw-600 text-white">{model.title}</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                {model.points.map((point, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className="flex items-center mb-0 fw-400 fs-md text-[#D7DEE5]"
                                                                    >
                                                                        <MWSVG
                                                                            id="tabler-icon-square-rounded-check-filled"
                                                                            svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                        />
                                                                        {point}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>

                        <span id="why-meet"></span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UsaEngageAfter;
